import React, { createContext, useContext, useState } from 'react';

const KitchenContext = createContext();

export const useKitchen = () => {
  const context = useContext(KitchenContext);
  // Return no-op defaults when not within provider (for customer users)
  if (!context) {
    return { 
      refreshTrigger: 0, 
      triggerKitchenRefresh: () => {},
      isKitchenReady: false,
      setIsKitchenReady: () => {},
      currentKitchenData: null,
      setCurrentKitchenData: () => {}
    };
  }
  return context;
};

export const KitchenProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isKitchenReady, setIsKitchenReady] = useState(false);
  const [kitchenCurrentStatus, setKitchenCurrentStatus] = useState('CLOSED');

  const [currentKitchenData, setCurrentKitchenData] = useState(null);

  const triggerKitchenRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <KitchenContext.Provider value={{ 
      refreshTrigger, 
      triggerKitchenRefresh,
      isKitchenReady,
      setIsKitchenReady,
      kitchenCurrentStatus,
      setKitchenCurrentStatus,
      currentKitchenData,
      setCurrentKitchenData 
    }}>
      {children}
    </KitchenContext.Provider>
  );
};
